import { Container, ContainerOptions, Ticker } from "pixi.js";

export class Marquee extends Container {
  private items: Container[] = [];
  private continuous: boolean = false;
  private scrollSpeed: number = 10;
  private scrollWidth: number;
  private gap: number = 50;
  private direction: 1 | -1 = -1;

  constructor({
    width,
    speed = 100,
    gap = 50,
    containerOptions,
  }: {
    width: number;
    speed?: number;
    gap?: number;
    containerOptions?: ContainerOptions;
  }) {
    super(containerOptions);

    this.scrollWidth = width;
    this.scrollSpeed = speed;
    this.gap = gap;

    Ticker.shared.add(this.onTick);
  }

  addItem = (item: Container): void => {
    this.items.push(item);
    this.addChild(item);
    this.layoutItems();
  };

  removeItem = (item: Container): void => {
    const index = this.items.indexOf(item);
    if (index > -1) {
      this.items.splice(index, 1);
      this.removeChild(item);
      this.layoutItems();
    }
  };

  private layoutItems = (): void => {
    let offset = 0;
    for (const item of this.items) {
      item.x = offset;
      offset += item.width + this.gap;
    }
  };

  private onTick = (ticker: Ticker) => {
    // return;
    if (this.items.length === 0) return;

    const delta = ticker.deltaTime;
    const movement = this.scrollSpeed * (delta / 60) * this.direction;

    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      item.x += movement;

      if (this.continuous) {
        if (this.direction === -1 && item.x + item.width < 0) {
          // Find rightmost item position
          const maxX = Math.max(...this.items.map((i) => i.x + i.width));
          item.x = maxX + this.gap;
        } else if (this.direction === 1 && item.x > (this.parent?.width || 0)) {
          // Find leftmost item position
          const minX = Math.min(...this.items.map((i) => i.x));
          item.x = minX - item.width - this.gap;
        }
      }
    }

    if (!this.continuous) {
      if (this.direction === -1) {
        // Scrolling left: wrap items that go off the left edge
        const first = this.items[0];
        if (first.x + first.width < 0) {
          const last = this.items[this.items.length - 1];
          first.x = last.x + last.width + this.gap;
          this.items.push(this.items.shift()!); // rotate array
        }
      } else {
        // Scrolling right: wrap items that go off the right edge
        const last = this.items[this.items.length - 1];
        if (last.x > this.scrollWidth || 0) {
          const first = this.items[0];
          last.x = first.x - last.width - this.gap;
          this.items.unshift(this.items.pop()!); // rotate array
        }
      }
    }
  };
}
